import { useCallback, useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

export default function ReferencePickerDialog({
  open, title, searchPlaceholder, fetchPage, getPrimary, getSecondary, onClose, onSelect,
  multiple = false, selectedKeys = [], itemKey = (item) => item.id, onToggle, onConfirm,
}) {
  const [query, setQuery] = useState("");
  const [result, setResult] = useState({ items: [], page: 1, limit: 10, total: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const load = useCallback(async (page = 1, search = "") => {
    setLoading(true); setError("");
    try {
      const data = await fetchPage({ page, search });
      setResult({ items: data?.items || [], page: Number(data?.page || page), limit: Number(data?.limit || 10), total: Number(data?.total || 0) });
    } catch (err) {
      setError(err?.response?.data?.error?.message || "Kayıtlar yüklenemedi.");
    } finally { setLoading(false); }
  }, [fetchPage]);

  useEffect(() => {
    if (!open) return;
    setQuery("");
    load(1, "");
  }, [open, load]);

  const totalPages = Math.max(1, Math.ceil(result.total / result.limit));
  return <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm" PaperProps={{ sx: { borderRadius: 3 } }}>
    <DialogTitle sx={{ pb: 1 }}>{title}</DialogTitle>
    <DialogContent dividers sx={{ bgcolor: "#f8fafc" }}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={1.25} sx={{ mb: 2 }}>
        <TextField value={query} onChange={(event) => setQuery(event.target.value)} onKeyDown={(event) => { if (event.key === "Enter") load(1, query); }} placeholder={searchPlaceholder} size="small" fullWidth autoFocus />
        <Button variant="contained" onClick={() => load(1, query)} disabled={loading}>Ara</Button>
      </Stack>
      {error ? <Alert severity="error" sx={{ mb: 1.5 }}>{error}</Alert> : null}
      <Paper variant="outlined" sx={{ overflow: "hidden", minHeight: 260 }}>
        {loading ? <Box sx={{ display: "grid", placeItems: "center", minHeight: 260 }}><CircularProgress size={28} /></Box> : result.items.length === 0 ? <Box sx={{ display: "grid", placeItems: "center", minHeight: 260, p: 3 }}><Typography color="text.secondary">Aramanıza uygun kayıt bulunamadı.</Typography></Box> : <List disablePadding>{result.items.map((item) => { const key = String(itemKey(item)); const checked = selectedKeys.map(String).includes(key); return <ListItemButton key={key} divider onClick={() => multiple ? onToggle?.(item) : onSelect(item)} sx={{ py: 1.4 }}><ListItemText primary={<Typography fontWeight={700}>{getPrimary(item)}</Typography>} secondary={getSecondary(item)} />{multiple ? <Checkbox edge="end" checked={checked} tabIndex={-1} disableRipple /> : null}</ListItemButton>; })}</List>}
      </Paper>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 1.5 }}>
        <Typography variant="caption" color="text.secondary">Toplam {result.total} kayıt · Sayfa {result.page} / {totalPages}</Typography>
        <Stack direction="row" spacing={1}><Button size="small" disabled={loading || result.page <= 1} onClick={() => load(result.page - 1, query)}>Önceki</Button><Button size="small" disabled={loading || result.page >= totalPages} onClick={() => load(result.page + 1, query)}>Sonraki</Button></Stack>
      </Stack>
    </DialogContent>
    <DialogActions>{multiple ? <><Button onClick={onClose} disabled={loading}>Vazgeç</Button><Button variant="contained" onClick={onConfirm || onClose} disabled={loading}>Seçimi Tamamla ({selectedKeys.length})</Button></> : <Button onClick={onClose} disabled={loading}>Kapat</Button>}</DialogActions>
  </Dialog>;
}
